import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const F = ({ id, label, value, onChange, placeholder, type = 'text' }) => (
  <div>
    <Label htmlFor={id}>{label}</Label>
    <Input id={id} data-testid={id} value={value ?? ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} type={type} />
  </div>
);

const AutomobileForm = ({ details, onChange }) => {
  const set = (k, v) => onChange({ ...details, [k]: v });
  return (
    <div className="space-y-4" data-testid="automobile-form">
      <div className="grid grid-cols-3 gap-3">
        <F id="ca-auto-make" label="Make" value={details.make} onChange={(v) => set('make', v)} placeholder="e.g. Land Rover" />
        <F id="ca-auto-model" label="Model" value={details.model} onChange={(v) => set('model', v)} placeholder="e.g. Range Rover" />
        <F id="ca-auto-year" label="Year" value={details.year} onChange={(v) => set('year', v)} placeholder="2024" type="number" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <F id="ca-auto-plate" label="Registration / Plate" value={details.registration_number} onChange={(v) => set('registration_number', v)} placeholder="e.g. AB12 CDE" />
        <F id="ca-auto-country" label="Country of registration" value={details.registration_country} onChange={(v) => set('registration_country', v)} placeholder="e.g. United Kingdom" />
      </div>
      <div>
        <Label htmlFor="ca-auto-ownership">Ownership type</Label>
        <Select value={details.ownership_type || ''} onValueChange={(v) => set('ownership_type', v)}>
          <SelectTrigger id="ca-auto-ownership" data-testid="ca-auto-ownership"><SelectValue placeholder="Pick one" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="owned">Owned outright</SelectItem>
            <SelectItem value="financed">Financed (loan)</SelectItem>
            <SelectItem value="leased">Leased</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {(details.ownership_type === 'financed' || details.ownership_type === 'leased') && (
        <div className="grid grid-cols-3 gap-3">
          <F id="ca-auto-lender" label="Lender / lease company" value={details.lender_name} onChange={(v) => set('lender_name', v)} placeholder="e.g. BMW Financial Services" />
          <F id="ca-auto-balance" label="Outstanding balance" value={details.loan_balance} onChange={(v) => set('loan_balance', v ? Number(v) : null)} placeholder="0" type="number" />
          <F id="ca-auto-monthly" label="Monthly payment" value={details.monthly_payment} onChange={(v) => set('monthly_payment', v ? Number(v) : null)} placeholder="0" type="number" />
        </div>
      )}
      <div className="grid grid-cols-2 gap-3">
        <F id="ca-auto-insurance" label="Insurance policy" value={details.insurance_reference} onChange={(v) => set('insurance_reference', v)} placeholder="e.g. Admiral #ADM-1234" />
        <F id="ca-auto-title-loc" label="Where the title / logbook lives" value={details.title_location} onChange={(v) => set('title_location', v)} placeholder="e.g. Home safe, top drawer" />
      </div>
    </div>
  );
};

export default AutomobileForm;
